export default __webpack_public_path__ + "static/media/roadmap.cbc90e5d.png";